/**
 * @generated SignedSource<<fb8c1f0d9e72757a9d176db03af67f84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FiltersContent_navigationCustomisation$data = {
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "Nav4FiltersContent_navigationCustomisation";
};
export type Nav4FiltersContent_navigationCustomisation$key = {
  readonly " $data"?: Nav4FiltersContent_navigationCustomisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent_navigationCustomisation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4FiltersContent_navigationCustomisation",
  "selections": [
    {
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};

(node as any).hash = "ce2c25c2e7d6bf7f7dae1f540021c99d";

export default node;
